<template>
    <div class="appointment">
      <div v-if="!show">
        <div class="avt">
          <div class="avt-top">
            <span @click="goApp()">全部景点>></span>
          </div>
          <div class="avt-bottom">
            <div class="avt-image">
              <img :src="spotlist.cover" />
            </div>
            <div class="avt-text">
              <div style="font-size: 0.19rem; letter-spacing: 1px">
                {{ spotlist.name }}
              </div>
              <div style="font-size: 0.1rem">
                {{ spotlist.englishName }}
              </div>
            </div>
            <div class="avt-right" @click="$router.push('/newOrderCenter')">
              我的门票
            </div>
          </div>
        </div>
        <div class="appointment-content">
          <div class="date">
            <div class="big-title">日期</div>
            <div class="mydate" @click="calendar = true">
              更多日期
              <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
          <div class="datelist">
            <div ref="mystyle" class="datelist-inner">
              <div v-for="(item, index) in datelist" :key="index" class="datelist-item" :style="`width:${scrollwidth * 0.22}px; margin-right:${scrollwidth * 0.031
                }px`" :class="dateindex == index ? 'active' : ''" @click="changedateindex(index)">
                {{ item.lable }}
              </div>
            </div>
          </div>
          <div class="date">
            <div class="big-title">时间</div>
            <div class="mydate" @click="timeshow = true">
              更多时间
              <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
          <div class="timelist">
            <div v-for="(item, index) in timelist" :key="index" style="width: 47%; margin-right: 3%">
              <div @click="changetime(item.id)" class="timelist-item" :class="timeindex == item.id ? 'active' : ''">
                <div style="font-size: 0.16rem">
                  {{ item.start }}-{{ item.end }}
                </div>
                <div class="Quantity" :class="timeindex == item.id ? 'active1' : ''">
                  <span v-if="item.limitCount != -1">余票{{ item.leftQuantity }}</span>
                  <span v-else>不限量</span>
                </div>
              </div>
            </div>
          </div>
          <!-- OLD -->
          <!-- <div v-if="isfree">
            <div class="date peopledate">
              <div class="big-title">购票</div>
            </div>
            <div class="Tickets">
              <div
                class="Tickets-item border"
                v-for="(item, index) in bookTourTickets"
                :key="index"
              >
                <div class="Tickets-item-top">
                  <div>{{ item.name }}</div>
                  <div>￥{{ item.price }}</div>
                </div>
                <div class="Tickets-item-bottom">
                  <div class="buyDesc" @click="myDesc(item)">购票须知>>></div>
                  <div
                    class="buy"
                    @click="
                      tickets = item.id;
                      show = true;
                    "
                  >
                    选择出行人
                  </div>
                </div>
              </div>
            </div>
            <div class="date peopledate">
              <div class="big-title">出行人</div>
            </div>
          </div>
          <div v-else>
            <div class="date peopledate">
              <div class="big-title">出行人信息</div>
            </div>
          </div>
          <div class="addshow-outer">
            <div
              v-if="!isfree"
              class="addshow"
              @click="
                tickets = 'free';
                show = true;
              "
            >
              <img src="../assets/addB.png" alt="" />
              添加出行人
            </div>
          </div>
          <div class="people-content">
            <div
              v-for="(item, index) in peoplelist"
              :key="index"
              class="people-item"
            >
              <div
                class="item-left"
                v-if="ischange(item.id)"
                :class="tickets != 'free' ? 'free' : ''"
              >
                <div class="change">
                  <img
                    src="../assets/delete.png"
                    alt=""
                    @click="changepeople(item.id)"
                  />
                </div>
                <div class="data">
                  <div style="font-size: 0.18rem; color: #000">
                    {{ item.name }}
                  </div>
                  <div>
                    <span>{{ item.cardType }}</span> {{ item.idCard }}
                  </div>
                  <div><span>手机号</span>{{ item.phone }}</div>
                </div>
                <div class="ticket" v-if="tickets != 'free'">
                  <div>{{ getTicket(item.id, "name") }}</div>
                  <div style="margin-top: 0.25rem">
                    ￥{{ getTicket(item.id, "price") }}
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- OLD -->
        <!-- <div class="appointment-bottom" v-if="isfree">
          <div class="amount">
            门票金额 :<span style="color: red">￥{{ totalAmount }}</span>
          </div>
          <div
            class="sumbit"
            @click="sumbit"
            v-if="
              isloading && date && timeindex != null && peopleindex.length != 0
            "
          >
            立即购买
          </div>
          <div
            class="sumbit"
            style="background-color: rgba(44, 114, 114, 0.7)"
            v-else
          >
            立即购买
          </div>
        </div>
        <div class="appointment-bottom1" v-else>
          <div
            class="sumbit"
            @click="sumbit"
            v-if="
              isloading && date && timeindex != null && peopleindex.length != 0
            "
          >
            立即门票
          </div>
        </div> -->
  
        <!-- NEW -->
        <div style="width: 90%; margin-left: 5%; border-bottom: 1px solid;"></div>
  
        <!-- <div class="sumbit-btn">
          <el-button style="background-color: #2c7272; color: white; width: 80%;" @click="gotosan">散客门票</el-button>
        </div>
        <div class="sumbit-btn">
          <el-button style="background-color: #2c7272; color: white; width: 80%;" @click="gototuan">团队门票</el-button>
        </div> -->
        <div class="sumbit-btn">
          <el-button style="background-color: #2c7272; color: white; width: 80%;" @click="submitsan">立即取票</el-button>
        </div>
        <el-dialog :visible.sync="promptshow" width="85%" :show-close="false" :close-on-click-modal="false"
          class="el-dialog-centent">
          <div class="pull-con">
            <div class="pull-con-title1">温馨提示</div>
            <div class="pull-con-title2">
              <p>
                1、实行实名制全门票制度，观众可提前七天通过线上渠道进行参观门票。如未提前门票且参观当日仍有余票时，观众可在当日进行门票。
              </p>
              <p>
                2、每张有效身份证件每天限定门票一次，单个账号每天最多实名门票3人(每个人的姓名和有效证件号码均需如实填写)，<span style="color: red">信息不符将不能进入，</span>敬请周知。
              </p>
              <p>
                3、未成年人，使用对应的身份证号码为其门票，参观时需出示门票二维码。
              </p>
              <p>4、门票成功后出示个人健康码或门票二维码均可进入。</p>
              <p>
                5、如您不能按时到达，请提前取消门票(取消截止时间为您的门票进入时间段结束时间之前)。连续三次或累计五次(30天之内)门票未到，将触发限制门票机制，限制门票机制触发之后30日以内，将无法门票参观。
              </p>
              <p>6、本单位试行限流措施，请在门票时间段入场，过时不候。</p>
              <p>谢谢理解和配合！</p>
            </div>
            <div class="pull-con-title3" @click="sumbit">知道了</div>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="validationshow" width="70%" :show-close="false" :close-on-click-modal="false"
          class="el-dialog-centent">
          <div class="pull-con">
            <div class="pull-con-title1">温馨提示</div>
            <div class="pull-con-title2">
              {{ validationtext }}
            </div>
            <div class="pull-con-title3" @click="validationshow = false">
              知道了
            </div>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="calendar" width="100%" :show-close="false" class="calendar">
          <div class="calendar">
            <div class="calendar-inner">
              <div class="calendar-top">
                <div>选择日期</div>
              </div>
              <div class="calendar-con">
                <div style="color: #2c7272">日</div>
                <div>一</div>
                <div>二</div>
                <div>三</div>
                <div>四</div>
                <div>五</div>
                <div style="color: #2c7272">六</div>
              </div>
              <div class="calendar-bottom">
                <div v-for="(myitem, myindex) in calendarlist" :key="myindex" class="calendar-bottom-item">
                  <div class="calendar-bottom-item-title">{{ myitem.title }}</div>
                  <div class="calendar-bottom-item-time">
                    <div v-for="(item1, index) in myitem.day" :key="index + '12'"></div>
                    <div v-for="(item, index) in myitem.num" :key="index">
                      <div class="optional" :class="date == myitem.value + '-' + getbignum(index + 1)
                          ? 'active'
                          : ''
                        " v-if="getdisabledDate(
        myitem.value + '-' + getbignum(index + 1)
      )
      " @click="changedate(myitem.value + '-' + getbignum(index + 1))
      ">
                        {{ index + 1 }}
                      </div>
                      <div class="notchoose" v-else>
                        {{ index + 1 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div @click="calendar = false" class="calendar-sumbit">确定</div>
            </div>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="timeshow" width="100%" :show-close="false" class="calendar">
          <div class="calendar">
            <div class="calendar-inner">
              <div class="calendar-top">
                <div>门票时段</div>
              </div>
              <div class="timelist" style="margin-top: 0.2rem; max-height: 2.3rem; overflow: scroll">
                <div v-for="(item, index) in ALLtimelist" :key="index" style="width: 47%; margin-right: 3%">
                  <!-- 先判断一下是时间段是否过期 -->
                  <div v-if="item.show == 1" class="timelist-item1">
                    <div style="font-size: 0.16rem">
                      {{ item.start }}-{{ item.end }}
                    </div>
                    <div style="font-size: 0.12rem">
                      <span v-if="item.limitCount != -1">余票{{ item.leftQuantity }}</span>
                      <span v-else>不限量</span>
                    </div>
                  </div>
                  <!-- 再判断一下余票是否为0 -->
                  <div v-if="item.show == 2" class="timelist-item1">
                    <div style="font-size: 0.16rem">
                      {{ item.start }}-{{ item.end }}
                    </div>
                    <div style="font-size: 0.12rem">
                      <span>余票0</span>
                    </div>
                  </div>
                  <!-- 两者都不存在才可以选择 -->
                  <div @click="changetime(item.id)" v-if="item.show == 3" class="timelist-item"
                    :class="timeindex == item.id ? 'active' : ''">
                    <div style="font-size: 0.16rem">
                      {{ item.start }}-{{ item.end }}
                    </div>
                    <div class="Quantity" :class="timeindex == item.id ? 'active1' : ''">
                      <span v-if="item.limitCount != -1">余票{{ item.leftQuantity }}</span>
                      <span v-else>不限量</span>
                    </div>
                  </div>
                </div>
              </div>
              <div @click="timeshow = false" class="calendar-sumbit" style="margin-top: 0.4rem">
                确定
              </div>
            </div>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="buyDescshow" width="100%" class="calendar radius">
          <div class="radius-top">
            <div>
              {{ buyDesc.name }}
            </div>
            <div @click="buyDescshow = false">
              <i class="el-icon-close" style="font-size: 25px"></i>
            </div>
          </div>
          <div v-html="buyDesc.desc" style="white-space: pre-wrap"></div>
        </el-dialog>
      </div>
      <people :peopleindex="peopleindex" :tickets="tickets" @changeshow="myshow" v-else></people>
    </div>
  </template>
  <script>
  import people from "../components/people.vue";
  export default {
    data() {
      return {
        id: "",
        //日期
        date: "",
        datelist: "",
        dateindex: 0,
        spotlist: "",
        //日历
        calendarlist: null,
        show: false,
        //闭馆
        disableDate: "",
        disableWeek: [],
        Daylist: [
          {
            value: 1,
            label: "周一",
          },
          {
            value: 2,
            label: "周二",
          },
          {
            value: 3,
            label: "周三",
          },
          {
            value: 4,
            label: "周四",
          },
          {
            value: 5,
            label: "周五",
          },
          {
            value: 6,
            label: "周六",
          },
          {
            value: 0,
            label: "周日",
          },
        ],
        //时间
        timelist: "",
        nowtimelist: "",
        ALLtimelist: "",
        timeindex: null,
        timeshow: false,
        //门票设置
        isfree: "", //是否免费
        bookTourTickets: "", //门票类型
        //购票须知
        buyDesc: {
          name: "",
          desc: "",
        },
        tickets: null, //立即购买的类型
        buyDescshow: false,
        totalAmount: 0, //总金额
        //出行人
        peopleindex: [],
        sublist: [],
        peoplelist: "",
        //弹框控制
        promptshow: false,
        validationshow: false,
        calendar: false,
        validationtext: "",
        scrollwidth: "",
        nochange: 0,
        isloading: true,
      };
    },
    components: {
      people,
    },
    watch: {
      //门票日期改变时查找位置做出选中样式
      date(val) {
        this.getdata();
        for (let i in this.datelist) {
          if (this.datelist[i].value == val) {
            this.dateindex = i;
            break;
          }
        }
      },
      //判断选择的日期位置做出相应的移动
      dateindex(val) {
        if (val > 2) {
          this.$refs.mystyle.style.transform = `translateX(-${this.scrollwidth * 0.25 * (val - 3)
            }px)`;
        } else {
          this.$refs.mystyle.style.transform = `translateX(0px)`;
        }
      },
      timeindex(val) {
        let index;
        for (const key in this.nowtimelist) {
          if (this.nowtimelist[key].id == val) {
            index = Math.floor(key);
          }
        }
        if (index != 0) {
          this.timelist = this.nowtimelist.slice(index - 1, index + 1);
        } else {
          this.timelist = this.nowtimelist.slice(0, 2);
        }
      },
      peopleindex(val) {
        if (this.tickets != "free") {
          let num = 0;
          for (const element of val) {
            let deleteindex = this.bookTourTickets.findIndex((value) => {
              return value.id == element.tickets;
            });
            num = num + this.bookTourTickets[deleteindex].price;
          }
          this.totalAmount = num;
        }
      },
    },
    created() {
      this.myolad();
    },
    mounted() {
      this.scrollwidth =
        document.getElementsByClassName("datelist")[0].clientWidth;
    },
    methods: {
      submitsan() {
      let input_len = 0;
      if (this.tickets == "free") {

        let index;
        for (const key in this.ALLtimelist) {
          if (this.ALLtimelist[key].id == this.timeindex) {
            index = key;
          }
        }

           this.sublist.push({ name: "", region: "" })
        // if (this.sanform.input1 != null) {
        //   input_len++;
        //   
        // }
        // if (this.sanform.input2 != null) { input_len++; this.sublist.push({ name: this.sanform.input2, region: this.sanform.place_value }) }
        // if (this.sanform.input3 != null) { input_len++; this.sublist.push({ name: this.sanform.input3, region: this.sanform.place_value }) }
        // if (this.sanform.input4 != null) { input_len++; this.sublist.push({ name: this.sanform.input4, region: this.sanform.place_value }) }
        if (this.limitCount != -1 && this.leftQuantity < input_len) {
          alert("余票不足");
          return false;
        }
        this.$axios.post("order/create", {
          tourId: this.id,
          appointDate: this.date,
          appointTimeStart:  this.ALLtimelist[index]['start'],
          appointTimeEnd: this.ALLtimelist[index]['end'],
          otaOrderDetailDTOs: this.sublist,
        })
          .then((res) => {
            this.isloading = true;
            if (res.code == 200) {
              if (res.data.isNeedPay) {
                window.WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  {
                    appId: res.data.payInfo.appId,
                    timeStamp: res.data.payInfo.timeStamp.toString(),
                    nonceStr: res.data.payInfo.nonceStr,
                    package: res.data.payInfo.package,
                    signType: res.data.payInfo.signType,
                    paySign: res.data.payInfo.paySign,
                  },
                  (res) => {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      this.$router.push("/newOrderCenter?code="+res.data.bookAppointments[0].code);
                    } else {
                      this.$router.push("/newOrderCenter?status=1");
                    }
                  }
                );
              } else {
                this.$router.push("/newOrderCenter?code="+res.data.bookAppointments[0].code);
              }
            } else {
              this.validationtext = res.msg;
              this.validationshow = true;
            }
          });
      }
    },
      // 散客门票
      gotosan() {
        let index;
        for (const key in this.ALLtimelist) {
          if (this.ALLtimelist[key].id == this.timeindex) {
            index = key;
          }
        }
        this.$router.push("/sanOrder?tourId=" + this.id 
                          + "&appointDate=" + this.date 
                          + "&appointTimeStart=" + this.ALLtimelist[index]['start']
                          + "&appointTimeEnd=" + this.ALLtimelist[index]['end']
                          + "&limitCount=" + this.ALLtimelist[index].limitCount
                          + "&leftQuantity=" + this.ALLtimelist[index].leftQuantity
                          + "&tickets=" + this.tickets)
      },
      // 团队门票
      gototuan() {
        let index;
        for (const key in this.ALLtimelist) {
          if (this.ALLtimelist[key].id == this.timeindex) {
            index = key;
          }
        }
        this.$router.push("/tuanOrder?tourId=" + this.id 
                          + "&appointDate=" + this.date 
                          + "&appointTimeStart=" + this.ALLtimelist[index]['start']
                          + "&appointTimeEnd=" + this.ALLtimelist[index]['end']
                          + "&limitCount=" + this.ALLtimelist[index].limitCount
                          + "&leftQuantity=" + this.ALLtimelist[index].leftQuantity
                          + "&tickets=" + this.tickets)
      },
      myolad() {
        this.id = this.$route.params.id;
        //获取景点信息
        this.$axios
          .get(`/book/tourInfo/${this.id}/?date=${this.date}`)
          .then((res) => {
            //获取景点信息
            this.spotlist = res.data.bookTour;
            //获取景点禁止门票日期
            if (res.data.bookTour.disableDate) {
              this.disableDate = JSON.parse(res.data.bookTour.disableDate);
            }
            //获取景点禁止门票周几
            if (res.data.bookTour.disableWeek) {
              let disableWeek = JSON.parse(res.data.bookTour.disableWeek);
              let data = [];
              for (const element of disableWeek) {
                for (const myval of this.Daylist) {
                  if (element == myval.label) {
                    data.push(myval.value);
                    break;
                  }
                }
              }
              this.disableWeek = data;
            }
            //获取景点是否为免费购票
            this.isfree = res.data.bookTour.price;
            if (!this.isfree) {
              this.tickets = "free";
            }
            //获取出行人列表
            this.$axios.get("/userpeo/list").then((res) => {
              this.peoplelist = res.data;
              //有出行人且为免费购票的情况下默认选择第一个出行人
              if (!this.isfree && res.data[0]) {
                this.peopleindex.push({
                  tickets: "free",
                  id: res.data[0].id,
                });
              }
            });
            //获取票价类型
            this.bookTourTickets = res.data.bookTourTickets;
            //闭馆时间顺延下一天，生成七天的可门票时间
            let datelist = [];
            let num = res.data.bookTour.date;
            if (
              num == 0 ||
              res.data.bookTour.status == 1 ||
              this.disableWeek.length == 7
            ) {
              this.validationtext = "该场所已关闭门票";
              this.validationshow = true;
              this.isloading = true;
            } else {
              for (let i = 0; datelist.length < num; i++) {
                let mys = 24 * 60 * 60 * 1000;
                let mytime = this.getDate(new Date().getTime() + mys * i, false);
                if (
                  this.disableWeek.indexOf(new Date(mytime).getDay()) == -1 &&
                  this.disableDate.indexOf(mytime) == -1
                ) {
                  datelist.push({
                    value: mytime,
                    lable: this.getDate(new Date().getTime() + mys * i, true),
                  });
                }
              }
            }
  
            this.datelist = datelist;
            //默认选择最新可以的日期
            this.date = this.datelist[0].value;
            this.getcalendarlist();
          });
      },
      goApp() {
        this.$router.push("/?moduleId=" + this.spotlist.moduleId);
      },
      //获取开放时间
      getdata() {
        this.$axios
          .get(`/book/tourInfo/${this.id}/?date=${this.date}`)
          .then((res) => {
            let ALLtimelist = res.data.bookOpenTimes;
            let nowtimelist = [];
            let index = null;
            for (let iterator of ALLtimelist) {
              if (this.getoverdue(iterator.end)) {
                this.$set(iterator, "show", 1); //时间段是否过期
              } else {
                if (iterator.leftQuantity == 0 && iterator.limitCount != -1) {
                  this.$set(iterator, "show", 2); //余票是否为0
                } else {
                  this.$set(iterator, "show", 3); //正常状态可选择
                }
              }
            }
            for (const iterator of ALLtimelist) {
              if (iterator.show == 3) {
                nowtimelist.push(iterator);
              }
            }
            for (const key in ALLtimelist) {
              if (ALLtimelist[key].show == 3) {
                index = ALLtimelist[key].id;
                break;
              }
            }
            for (const key in ALLtimelist) {
              if (ALLtimelist[key].show == 3) {
                index = ALLtimelist[key].id;
                break;
              }
            }
            this.timeindex = index;
            this.nowtimelist = nowtimelist;
            this.timelist = nowtimelist.slice(0, 2);
            this.ALLtimelist = ALLtimelist;
          });
      },
      //生成yyyy-mm-dd格式日期
      getDate(time, show) {
        let newtime = new Date(time);
        let my_y = newtime.getFullYear();
        let my_m =
          newtime.getMonth() + 1 > 9
            ? newtime.getMonth() + 1
            : "0" + (newtime.getMonth() + 1);
        let my_d =
          newtime.getDate() > 9 ? newtime.getDate() : "0" + newtime.getDate();
        let data;
        if (show) {
          data = my_m + "-" + my_d;
        } else {
          data = my_y + "-" + my_m + "-" + my_d;
        }
        return data;
      },
      //点击时间
      changetime(index) {
        this.timeindex = index;
      },
      //点击日历
      changedate(date) {
        this.date = date;
      },
      //点击日期
      changedateindex(index) {
        this.date = this.datelist[index].value;
      },
      // 取消出行人
      changepeople(id) {
        let deleteindex = this.peopleindex.findIndex((value) => {
          return value.id == id;
        });
        this.$delete(this.peopleindex, deleteindex);
      },
      // 判断是否为选中出行人
      ischange(id) {
        let show = false;
        this.peopleindex.forEach((element) => {
          if (id == element.id) {
            show = true;
          }
        });
        return show;
      },
      //门票提交
      sumbit() {
        this.isloading = false;
        if (!this.date) {
          this.validationtext = "请选择门票日期";
          this.validationshow = true;
          this.isloading = true;
          return false;
        }
        if (this.timeindex == null) {
          this.validationtext = "请选择门票时间";
          this.validationshow = true;
          this.isloading = true;
          return false;
        }
        if (this.peopleindex.length == 0) {
          this.validationtext = "至少勾选一个出行人";
          this.validationshow = true;
          this.isloading = true;
          return false;
        }
        let index;
        for (const key in this.ALLtimelist) {
          if (this.ALLtimelist[key].id == this.timeindex) {
            index = key;
          }
        }
        if (
          this.ALLtimelist[index].limitCount != -1 &&
          this.ALLtimelist[index].leftQuantity < this.peopleindex.length
        ) {
          this.validationtext = "余票不足";
          this.validationshow = true;
          this.isloading = true;
          return false;
        }
        if (this.nochange == 0) {
          this.promptshow = true;
          this.nochange = 1;
          return false;
        } else {
          this.promptshow = false;
        }
        let datalist = [];
        this.peopleindex.forEach((element) => {
          for (const key in this.peoplelist) {
            if (this.peoplelist[key].id == element.id) {
              let list;
              if (this.tickets != "free") {
                list = {
                  travelId: element.id,
                  name: this.peoplelist[key].name,
                  // identity: this.peoplelist[key].idCard,
                  // phone: this.peoplelist[key].phone,
                  ticketId: element.tickets,
                };
              } else {
                list = {
                  travelId: element.id,
                  name: this.peoplelist[key].name,
                  // identity: this.peoplelist[key].idCard,
                  // phone: this.peoplelist[key].phone,
                  region: "上海",
                };
              }
              datalist.push(list);
              break;
            }
          }
        });
        this.$axios.post("order/create", {
          tourId: this.id,
          appointDate: this.date,
          appointTimeStart: this.ALLtimelist[index]["start"],
          appointTimeEnd: this.ALLtimelist[index]["end"],
          otaOrderDetailDTOs: datalist,
        })
          .then((res) => {
            console.log(res);
            this.isloading = true;
            if (res.code == 200) {
              if (res.data.isNeedPay) {
                window.WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  {
                    appId: res.data.payInfo.appId,
                    timeStamp: res.data.payInfo.timeStamp.toString(),
                    nonceStr: res.data.payInfo.nonceStr,
                    package: res.data.payInfo.package,
                    signType: res.data.payInfo.signType,
                    paySign: res.data.payInfo.paySign,
                  },
                  (res) => {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      this.$router.push("/newOrderCenter");
                    } else {
                      this.$router.push("/newOrderCenter?status=1");
                    }
                  }
                );
              } else {
                this.$router.push("/newOrderCenter");
              }
            } else {
              this.validationtext = res.msg;
              this.validationshow = true;
            }
          });
      },
      //当关闭添加出现人页面,滚动到页面底部
      myshow() {
        this.show = false;
        this.$axios.get("/userpeo/list").then((res) => {
          this.peoplelist = res.data;
          this.$nextTick(() => {
            let Height1 =
              document.body.clientHeight || document.documentElement.clientHeight;
            let Height2 =
              document.getElementsByClassName("appointment")[0].offsetHeight;
            document.documentElement.scrollTop = Height2 - Height1;
          });
        });
      },
      //生成本月和下个月的日历
      getcalendarlist() {
        let newtime = new Date(this.datelist[0].value); //生成最近一个可门票日期
        let data = [
          {
            title: null,
            num: null,
            value: null,
            day: null,
          },
          {
            title: null,
            num: null,
            value: null,
            day: null,
          },
        ];
        let my_m1 =
          newtime.getMonth() + 1 > 9
            ? newtime.getMonth() + 1
            : "0" + (newtime.getMonth() + 1); //获取newtime月数
        let my_y1 = newtime.getFullYear(); //获取newtime年数
        let my_m2; //下一月的月数
        let my_y2; //下一月的年数
        if (newtime.getMonth() != 11) {
          //判断newtime是否为12月份
          my_y2 = newtime.getFullYear(); //不为12月份时，my_y2==my_y1,my_y2=my_y1+1
          my_m2 =
            newtime.getMonth() + 2 > 9
              ? newtime.getMonth() + 2
              : "0" + (newtime.getMonth() + 2);
        } else {
          //为12月份时，my_y2=my_y1+1,my_y2=01
          my_y2 = Number(newtime.getFullYear()) + 1;
          my_m2 = "01";
        }
        data[0].title = my_y1 + "年" + my_m1 + "月";
        data[0].value = my_y1 + "-" + my_m1;
        data[0].num = new Date(my_y1, my_m1, 0).getDate();
        data[0].day = new Date(my_y1 + "-" + my_m1 + "-01").getDay();
        data[1].title = my_y2 + "年" + my_m2 + "月";
        data[1].value = my_y2 + "-" + my_m2;
        data[1].num = new Date(my_y2, my_m2, 0).getDate();
        data[1].day = new Date(my_y2 + "-" + my_m2 + "-01").getDay();
        this.calendarlist = data;
      },
      //日历的不可门票判断
      getdisabledDate(mytime) {
        let show = false;
        //日期不在生成的7天日历列表中就支灰
        for (const element of this.datelist) {
          if (element.value == mytime) {
            show = true;
            break;
          }
        }
        return show;
      },
      //获取日历格式日期
      getbignum(index) {
        return index > 9 ? index : "0" + index;
      },
      //判断门票时间段是否过期
      getoverdue(val) {
        let valitem =
          new Date(`${this.date} ${val}:00`).getTime() ||
          new Date(`${this.date} ${val}:00`.replace(/-/g, "/")).getTime() ||
          new Date(`${this.date}T${val}:00`).getTime();
        if (new Date().getTime() > valitem) {
          return true;
        } else {
          return false;
        }
      },
      //购票须知
      myDesc(item) {
        this.buyDesc.name = item.name;
        this.buyDesc.desc = item.buyDesc;
        this.buyDescshow = true;
      },
      getTicket(value, mykey) {
        let tickets;
        for (const key of this.peopleindex) {
          if (value == key.id) {
            tickets = key.tickets;
            break;
          }
        }
        let data;
        for (const elememt of this.bookTourTickets) {
          if (tickets == elememt.id) {
            data = elememt[mykey];
            break;
          }
        }
  
        return data;
      },
    },
  };
  </script>
  <style>
  .sumbit-btn {
    width: 100%;
    margin-top: 0.3rem;
    text-align: center;
  }
  
  .el-dialog-centent {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .el-dialog {
    margin: 0 0 !important;
    display: flex;
    flex-direction: column;
  }
  
  .el-dialog__header {
    display: none;
  }
  
  .el-dialog__body {
    padding: 0.2rem;
  }
  </style>
  <style scoped lang="less">
  .big-title {
    font-size: 0.22rem;
    font-weight: 550;
  }
  
  .timelist {
    flex-wrap: wrap;
    display: flex;
  
    .timelist-item {
      background-color: #fff;
      flex-shrink: 0;
      border-radius: 0.05rem;
      border: 1px solid #979797;
      margin-bottom: 0.1rem;
      padding: 0.05rem 0 0.05rem 0.1rem;
      box-sizing: border-box;
      width: 100%;
      margin-right: 3%;
      display: inline-block;
  
      .Quantity {
        color: #807e7e;
        font-size: 0.12rem;
      }
  
      .active1 {
        color: #fff;
      }
    }
  
    .timelist-item1 {
      background-color: #fff;
      flex-shrink: 0;
      border-radius: 0.05rem;
      border: 1px solid #979797;
      margin-bottom: 0.1rem;
      padding: 0.05rem 0 0.05rem 0.1rem;
      box-sizing: border-box;
      color: #807e7e;
      opacity: 0.4;
      width: 100%;
      margin-right: 3%;
      float: left;
    }
  
    .active {
      background-color: #2c7272;
      color: #fff;
      border: 1px solid #2c7272;
    }
  }
  
  @keyframes scale {
    50% {
      transform: scale(1.05, 1.02);
    }
  }
  
  .appointment {
    min-height: 100%;
    position: relative;
  
    .avt {
      background-color: #2c7272;
      width: 100%;
      color: #fff;
      padding: 0 0.2rem;
      box-sizing: border-box;
      height: 1.4rem;
  
      .avt-top {
        text-align: right;
        letter-spacing: 1px;
        font-size: 0.15rem;
        padding-top: 0.1rem;
      }
  
      .avt-bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
  
        .avt-image {
          border-radius: 50%;
  
          img {
            border: 2px solid rgba(255, 255, 255, 0.4);
            box-sizing: border-box;
            width: 0.7rem;
            height: 0.7rem;
            border-radius: 50%;
          }
        }
  
        .avt-text {
          width: 50%;
        }
  
        .avt-right {
          color: #2c7272;
          font-size: 0.14rem;
          background-color: #fff;
          border-radius: 0.3rem;
          padding: 0.04rem 0.1rem;
        }
      }
    }
  
    .appointment-content {
      background-color: #fff;
      border-top-left-radius: 0.15rem;
      border-top-right-radius: 0.15rem;
      position: relative;
      top: -0.2rem;
      padding: 0 0.2rem;
      box-sizing: border-box;
  
      .date {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.3rem 0 0.1rem 0;
  
        .mydate {
          color: #2c7272;
          font-weight: 700;
        }
      }
  
      .datelist {
        width: 100%;
        display: flex;
        overflow: hidden;
        padding-right: 1px;
  
        .datelist-inner {
          display: flex;
  
          .datelist-item {
            flex-shrink: 0;
            background-color: #fff;
            line-height: 0.4rem;
            text-align: center;
            border-radius: 0.05rem;
            border: 1px solid rgba(151, 151, 151, 0.4);
            font-size: 0.16rem;
            display: inline-block;
            box-sizing: border-box;
          }
  
          .active {
            border: 1px solid #2c7272;
            background-color: #2c7272;
            color: #fff;
          }
        }
      }
  
      .Tickets {
        margin-top: 0.15rem;
  
        .Tickets-item {
          margin-bottom: 0.2rem;
          padding-bottom: 0.15rem;
  
          .Tickets-item-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.2rem;
            // font-weight: 800;
            margin-bottom: 0.1rem;
          }
  
          .Tickets-item-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 0.15rem;
  
            .buyDesc {
              color: rgba(20, 35, 35, 0.5);
              font-size: 0.15rem;
            }
  
            .buy {
              padding: 0.05rem 0.1rem;
              font-size: 0.12rem;
              letter-spacing: 0.03rem;
              background-color: #2c7272;
              color: #fff;
              border-radius: 0.15rem;
            }
          }
        }
  
        .border {
          border-bottom: 1px solid rgb(209, 208, 208);
        }
      }
  
      .peopledate {
        padding: 0.1rem 0 0 0;
        margin-top: 0.3rem;
        height: 0.3rem;
      }
  
      .addshow-outer {
        margin-top: 0.2rem;
  
        .addshow {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          background: rgba(44, 114, 114, 0.2);
          border-radius: 0.05rem;
          line-height: 0.4rem;
          color: #2c7272;
          text-align: center;
          font-size: 0.16rem;
  
          img {
            width: 0.2rem;
            margin-right: 0.05rem;
          }
        }
      }
  
      .people-content {
        padding-bottom: 0.8rem;
        padding-top: 0.2rem;
  
        .people-item {
          .item-left {
            display: flex;
            align-items: flex-start;
  
            padding-top: 0.15rem;
            padding-bottom: 0.1rem;
            border-bottom: 1px solid rgba(20, 35, 35, 0.2);
  
            .change {
              width: 0.2rem;
              height: 0.2rem;
  
              img {
                width: 100%;
                height: 100%;
              }
            }
  
            .data {
              margin-left: 0.2rem;
              line-height: 0.25rem;
              color: #868686;
              font-size: 0.13rem;
  
              span {
                margin-right: 0.1rem;
              }
            }
  
            .ticket {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
            }
          }
  
          .free {
            justify-content: space-between;
          }
  
          .editor {
            font-size: 0.2rem;
            vertical-align: text-top;
          }
        }
      }
    }
  
    .appointment-bottom {
      width: 100%;
      background-color: #fff;
      display: flex;
      line-height: 0.4rem;
      position: fixed;
      bottom: 0;
      font-size: 0.16rem;
  
      .amount {
        width: 60%;
        text-indent: 0.1rem;
      }
  
      .sumbit {
        background-color: #2c7272;
        color: #fff;
        width: 40%;
        text-align: center;
      }
    }
  
    .appointment-bottom1 {
      width: 100%;
      padding: 0 0.2rem;
      box-sizing: border-box;
      position: fixed;
      bottom: 0.2rem;
      font-size: 0.16rem;
  
      .sumbit {
        background-color: #2c7272;
        line-height: 0.4rem;
        color: #fff;
        width: 95%;
        text-align: center;
        margin: 0 auto;
        border-radius: 0.07rem;
        animation: scale 1s linear infinite;
      }
    }
  
    .pull-con {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
  
      .pull-con-title1 {
        font-weight: 500;
        color: #142323;
        letter-spacing: 1px;
        font-size: 0.2rem;
        font-weight: 600;
        text-align: center;
      }
  
      .pull-con-title2 {
        margin-top: 0.2rem;
        font-size: 0.12rem;
  
        p {
          margin-bottom: 0.1rem;
          color: #142323;
          letter-spacing: 2px;
          text-align: justify;
        }
      }
  
      .pull-con-title3 {
        color: #fff;
        width: 80%;
        line-height: 0.31rem;
        background-color: #2c7272;
        font-size: 0.14rem;
        text-align: center;
        border-radius: 0.04rem;
        margin-top: 0.2rem;
      }
    }
  
    .calendar {
      display: flex;
      align-items: flex-end;
      justify-content: center;
  
      .calendar-inner {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
      }
  
      .calendar-top {
        text-align: center;
        font-size: 0.2rem;
        font-weight: 600;
        position: relative;
  
        .close {
          position: absolute;
          left: 0;
          font-size: 0.24rem;
        }
      }
  
      .calendar-con {
        display: flex;
        width: 100%;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  
        div {
          width: 14.2%;
          line-height: 0.4rem;
          text-align: center;
        }
      }
  
      .calendar-bottom {
        height: 3rem;
        overflow: scroll;
  
        .calendar-bottom-item {
          margin-bottom: 0.3rem;
  
          .calendar-bottom-item-title {
            line-height: 0.4rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            text-align: center;
            font-size: 0.14rem;
          }
  
          .calendar-bottom-item-time {
            display: flex;
            width: 100%;
            flex-wrap: wrap;
  
            div {
              flex-shrink: 0;
              width: 14.2%;
              line-height: 0.4rem;
              font-size: 0.14rem;
              text-align: center;
  
              .optional {
                width: 100%;
                height: 100%;
                text-align: center;
              }
  
              .active {
                background: #2c7272;
                color: #fff;
              }
  
              .notchoose {
                width: 100%;
                height: 100%;
                color: #b8b8b8;
              }
            }
          }
        }
      }
  
      .calendar-sumbit {
        margin: 0 auto;
        line-height: 0.35rem;
        text-align: center;
        width: 1.5rem;
        background-color: #2c7272;
        color: #fff;
        border-radius: 0.17rem;
        font-size: 0.16rem;
        margin-top: 0.2rem;
      }
    }
  
    .radius {
      ::v-deep .el-dialog {
        border-top-left-radius: 0.18rem;
        border-top-right-radius: 0.18rem;
      }
  
      .radius-top {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 0.2rem;
        color: #000;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  </style>